import { render, staticRenderFns } from "./categorySideView.vue?vue&type=template&id=5348d351"
import script from "./categorySideView.js?vue&type=script&lang=js&external"
export * from "./categorySideView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports